






















import { Component, Vue, Prop } from 'vue-property-decorator'
import Event from '@/models/event'
import moment from 'moment'


@Component
export default class EventCard extends Vue {

    @Prop(Object) event!: Event
    @Prop({type: Boolean, default: false}) upcoming!: boolean

    get getAverageBeer() {
        if (this.event.ratings === undefined || this.event.ratings.length === 0) {
            return 0
        }

        return (this.event.ratings.reduce((accumulator, currentValue) => accumulator + currentValue.beer, 0)
            / this.event.ratings.length).toFixed(1)
    }

    get getAverageExperience() {
        if (this.event.ratings === undefined || this.event.ratings.length === 0) {
            return 0
        }

        return (this.event.ratings.reduce((accumulator, currentValue) => accumulator + currentValue.experience, 0)
            / this.event.ratings.length).toFixed(1)
    }

    get formattedDate() {
        return this.event.at.format('MMM DD, YYYY hh:mm A')
    }

    get addToGoogleCalendar() {
        const title = encodeURIComponent('CBC at ' + this.event.brewery.name)
        const loc = encodeURIComponent(this.event.location)
        const startDate = this.event.at.clone()
        const startDateString = startDate.toISOString().replace(/[-:]|\.\d+/g, '')
        const endDate = startDate.clone().add(4, 'hours')
        const endDateString = endDate.toISOString().replace(/[-:]|\.\d+/g, '')

        return 'http://www.google.com/calendar/event?action=TEMPLATE&trp=false&text=' + title +
            '&details=' + title + '&location=' + loc + '&dates=' + startDateString + '/' + endDateString
    }
}
